// Generated types for AnalysisRecord
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { AttachedRecordReadAPI, AttachedRecordWriteAPI } from '../../shared/types/attachedrecord';
import { RFLPElementReadAPI, RFLPElementWriteAPI } from './rflpelement';
import { AttachedRecordReadAPISchemaObject, AttachedRecordWriteAPISchemaObject } from '../../shared/types/attachedrecord';
import { RFLPElementReadAPISchemaObject, RFLPElementWriteAPISchemaObject } from './rflpelement';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface AnalysisRecordReadAPI extends RFLPElementReadAPI, AttachedRecordReadAPI {
  /** When this analysis was run. */
  run_at?: string;
  /** Canonical authored/dependency input identity validated before publication. */
  input_identity?: string | null;
  /** Total finding count across all rules. */
  total?: number;
  /** JSON-encoded histogram of finding codes → counts. */
  by_code_json?: string | null;
  /** JSON-encoded list of findings. Each entry has {code, severity, node_id, node_type, node_name, message}. */
  findings_json?: string | null;
  /** LLM-generated narrative summary — filled by the completeness-analysis skill after reading the findings. */
  summary?: string | null;
  /** JSON-encoded list of layer codes the caller filtered by, or null for a full run. The persisted `findings` list always covers the FULL run regardless — this field captures the filter the *response* was scoped to, for audit / replay. */
  layers_filter_json?: string | null;
  /** False when some rules could not run in the context the check read (their inputs were unavailable): the findings are only the other rules'. Never a complete analysis or a passed gate. */
  complete?: boolean;
  /** JSON-encoded {missing: [...], rules: [...]} of an incomplete run: the inputs that were unavailable and the rules they stopped. */
  incomplete_json?: string | null;
}

export interface AnalysisRecordWriteAPI extends RFLPElementWriteAPI, AttachedRecordWriteAPI {
  /** When this analysis was run. */
  run_at?: string;
  /** Total finding count across all rules. */
  total?: number;
  /** JSON-encoded histogram of finding codes → counts. */
  by_code_json?: string | null;
  /** JSON-encoded list of findings. Each entry has {code, severity, node_id, node_type, node_name, message}. */
  findings_json?: string | null;
  /** LLM-generated narrative summary — filled by the completeness-analysis skill after reading the findings. */
  summary?: string | null;
  /** JSON-encoded list of layer codes the caller filtered by, or null for a full run. The persisted `findings` list always covers the FULL run regardless — this field captures the filter the *response* was scoped to, for audit / replay. */
  layers_filter_json?: string | null;
  /** False when some rules could not run in the context the check read (their inputs were unavailable): the findings are only the other rules'. Never a complete analysis or a passed gate. */
  complete?: boolean;
  /** JSON-encoded {missing: [...], rules: [...]} of an incomplete run: the inputs that were unavailable and the rules they stopped. */
  incomplete_json?: string | null;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const AnalysisRecordReadAPISchema: z.ZodType<AnalysisRecordReadAPI> = RFLPElementReadAPISchemaObject.extend(AttachedRecordReadAPISchemaObject.shape).extend({
  run_at: z.string().optional(),
  input_identity: z.string().nullable().optional(),
  total: z.number().optional(),
  by_code_json: z.string().nullable().optional(),
  findings_json: z.string().nullable().optional(),
  summary: z.string().nullable().optional(),
  layers_filter_json: z.string().nullable().optional(),
  complete: z.boolean().optional(),
  incomplete_json: z.string().nullable().optional(),
}).passthrough();

export const AnalysisRecordWriteAPISchema: z.ZodType<AnalysisRecordWriteAPI> = RFLPElementWriteAPISchemaObject.extend(AttachedRecordWriteAPISchemaObject.shape).extend({
  run_at: z.string().optional(),
  total: z.number().optional(),
  by_code_json: z.string().nullable().optional(),
  findings_json: z.string().nullable().optional(),
  summary: z.string().nullable().optional(),
  layers_filter_json: z.string().nullable().optional(),
  complete: z.boolean().optional(),
  incomplete_json: z.string().nullable().optional(),
}).passthrough();
